import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { isMarketingCalendarEnabledForSite } from "@/features/MarketingCalendar/flag";
import {
  hasElevatedAccessValue,
  usePrivilegedModeStore,
} from "@/utils/privilegedMode";

export const Route = createFileRoute("/_auth/marketing-calendar/$siteId")({
  beforeLoad: ({ context, params }) => {
    const disabled = usePrivilegedModeStore.getState().disabled;
    const canAccess =
      isMarketingCalendarEnabledForSite(params.siteId) &&
      hasElevatedAccessValue(context.auth?.user?.user.role, disabled);
    if (!canAccess) {
      // "/" re-runs the home resolution (login, last-selected site, agency).
      throw redirect({ to: "/" });
    }
  },
  component: Outlet,
});
